export const ALG = {
  lookup: "allergy-lookup",
  search: "allergy-lookup-search",
  typeFilter: "allergy-lookup-type",
  results: "allergy-lookup-results",
  result: "allergy-lookup-result",
  loading: "allergy-lookup-loading",
  empty: "allergy-lookup-empty",
  hint: "allergy-lookup-hint",
  error: "allergy-lookup-error",
  selected: "allergy-lookup-selected",
  selectedName: "allergy-lookup-selected-name",
  selectedType: "allergy-lookup-selected-type",
  change: "allergy-lookup-change",
  panel: "patient-chart-allergies",
  title: "patient-chart-allergies-title",
  close: "patient-chart-allergies-close",
  review: "patient-chart-allergies-review",
  lastReviewed: "patient-chart-allergies-last-reviewed",
  markReviewed: "patient-chart-allergies-mark-reviewed",
  reconcileNote: "patient-chart-allergies-reconcile-note",
  emptyState: "patient-chart-allergies-empty",
  nka: "patient-chart-allergies-nka",
  nkaButton: "patient-chart-allergies-nka-btn",
  add: "patient-chart-allergies-add",
  form: "patient-chart-allergies-form",
  table: "patient-chart-allergies-table",
  row: "patient-chart-allergies-row",
  kind: "patient-chart-allergies-kind",
  clinicalStatus: "patient-chart-allergies-clinical-status",
  verification: "patient-chart-allergies-verification",
  criticality: "patient-chart-allergies-criticality",
  category: "patient-chart-allergies-category",
  manifestation: "patient-chart-allergies-manifestation",
  severity: "patient-chart-allergies-severity",
  description: "patient-chart-allergies-description",
  route: "patient-chart-allergies-route",
  onset: "patient-chart-allergies-onset",
  note: "patient-chart-allergies-note",
  save: "patient-chart-allergies-save",
  cancel: "patient-chart-allergies-cancel",
  edit: "patient-chart-allergies-edit",
  deactivate: "patient-chart-allergies-deactivate",
  deactivateDialog: "patient-chart-allergies-deactivate-dialog",
  deactivateConfirm: "patient-chart-allergies-deactivate-confirm",
  includeInactive: "patient-chart-allergies-include-inactive",
  loadError: "patient-chart-allergies-load-error",
  saveError: "patient-chart-allergies-save-error",
  card: "patient-chart-card-allergies",
  viewAll: "patient-chart-view-all-allergies",
};
